import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ListClosureHistoryChild from "./ListClosureHistoryChild";

const ListClosureHistory = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ListClosureHistoryChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ListClosureHistory;
